import "./style.css";
import { gameController } from "./game-controller";

gameController();
